<div class="drp-view">
    <div class="drp-view-acoes text-right" *ngIf="canShowDRPCustos">
        <button type="button" class="btn btn-link btn-sm" (click)="alternarDetalhe()"
                [sgtTooltip]="detalhado ? 'Mostrar apenas as etapas da cascata' : 'Abrir cada componente do D.R.P'">
            <i class="fas" [class.fa-compress-alt]="detalhado" [class.fa-expand-alt]="!detalhado" aria-hidden="true"></i>
            {{detalhado ? 'Resumir' : 'Detalhar'}}
        </button>
    </div>
    <div class="drp-view-body">
        <!-- Pedido-->
        <sgt-collapse-group
            [title]="titlePedidoGroup"
            collpaseTitleMarginTop="10px"
            collpaseTitleMarginLeft="7px"
            collpaseTitleMarginRight="7px">
            <sgt-pedido-drp-view
                [drp]="pedido?.drp"
                [detalhado]="detalhado">
            </sgt-pedido-drp-view>
        </sgt-collapse-group>
    
        <!-- Itens-->
        <sgt-collapse-group
            [title]="titleItensGroup"
            containerCollpaseMarginBottom="0px"
            collpaseTitleMarginLeft="7px"
            collpaseTitleMarginRight="7px">
            <sgt-pedido-item-drp-view
                #itemView
                [pedidoItens]="pedido?.itens"
                [detalhado]="detalhado">
            </sgt-pedido-item-drp-view>
        </sgt-collapse-group>
    </div>
</div>
